import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { previewModalIndexSet, previewModalExpansionToggle } from 'Global/Stores/previewModalGeneric'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    expanded: selectors.expanded(state),
    index: selectors.index(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    setCurrentIndex: index => dispatch(previewModalIndexSet(index)),
    toggleExpansion: () => dispatch(previewModalExpansionToggle()),
  })

  Enhancer.displayName = 'PreviewModalGenericEnhancer'

  Enhancer.propTypes = {
    expanded: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    open: PropTypes.bool.isRequired,
    pictures: PropTypes.array.isRequired,
    setCurrentIndex: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    toggleExpansion: PropTypes.func.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
